var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResultsImage = function SvgNoResultsImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 136,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#33312D",
    fillOpacity: 0.7,
    d: "M135.114 75.07c0 33.597-27.238 60.835-60.835 60.93-33.596 0-60.834-27.238-60.93-60.835-.094-33.596 27.239-60.929 60.835-60.929h.095c33.502-.095 60.835 27.048 60.835 60.645z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M32.644 1.727C12.81-6.246-6.763 14.904 3.894 34.17c4.841 8.751 16.87 15.798 30.874 9.133l9.735 2.793c1.51.433 2.906-.963 2.482-2.481-.581-2.081-1.958-6.987-2.763-9.646C50.26 23.151 46.189 7.17 32.644 1.727"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F768AB",
    d: "M26.179 11.21a6.3 6.3 0 0 1 2.116 1.198 5.54 5.54 0 0 1 1.46 1.982q.516 1.168.516 2.598 0 1.645-.841 3.226-.663 1.214-2.05 2.644-.073.06-.169.161-.096.1-.243.223a8 8 0 0 0-.885.937 1.85 1.85 0 0 0-.413 1.122q-.015.215-.015.66 0 1.215-.295 1.799-.397.737-1.533.737-1.166 0-1.593-.983-.295-.691-.295-2.044 0-1.06.317-1.936a7.2 7.2 0 0 1 .863-1.66 10 10 0 0 1 1.105-1.275q.695-.675 1.158-1.214.465-.539.774-1.091a2.55 2.55 0 0 0 .34-1.306q0-1.137-.9-1.768-.752-.491-1.961-.492a3.3 3.3 0 0 0-1.055.17 10 10 0 0 0-1.142.476q-.709.338-1.099.492t-.774.154q-.767 0-1.312-.6a1.85 1.85 0 0 1-.576-1.367q0-1.062 1.165-1.89.93-.631 2.492-1.046 1.239-.323 2.301-.323 1.327 0 2.543.415m-1.313 19.454q.435.2.76.538.324.338.516.791.19.454.191.93 0 .477-.191.93-.192.453-.516.791-.325.339-.76.538-.435.2-.892.2t-.892-.2a2.5 2.5 0 0 1-.76-.538 2.6 2.6 0 0 1-.516-.791 2.36 2.36 0 0 1 0-1.86q.192-.453.516-.791.325-.339.76-.538.435-.2.892-.2t.892.2"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#6E6FAC",
    d: "m88.619 91.879-5.479 3.228 13.154 22.323 5.479-3.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M76.367 108.383c17.768 0 32.173-14.405 32.173-32.173S94.135 44.037 76.367 44.037 44.194 58.44 44.194 76.21c0 17.768 14.404 32.173 32.173 32.173"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9EC",
    fillRule: "evenodd",
    d: "M84.419 82.463a2.04 2.04 0 0 1-.314 2.867L81 87.822a2.04 2.04 0 1 1-2.554-3.181l3.104-2.492a2.04 2.04 0 0 1 2.868.314",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3E1",
    d: "M98.005 52.389c13.192 11.958 14.141 32.267 2.183 45.46-8.352 9.205-21.164 12.717-33.027 9.205l2.278.095s20.025-1.613 26.668-22.967c4.176-16.324.095-24.96-4.365-36.254 2.372 1.329 4.46 2.752 6.263 4.46",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E6FAC",
    fillRule: "evenodd",
    d: "M76.367 48.11c-15.519 0-28.1 12.58-28.1 28.1 0 15.519 12.581 28.099 28.1 28.099s28.1-12.58 28.1-28.1c0-15.519-12.58-28.1-28.1-28.1m-36.246 28.1c0-20.019 16.228-36.247 36.246-36.247s36.247 16.228 36.247 36.246-16.229 36.247-36.247 36.247-36.246-16.228-36.246-36.247",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605D5A",
    d: "M69.691 82.819c1.212-.624 1.28-2.905.154-5.095s-3.023-3.461-4.235-2.838c-1.212.624-1.28 2.905-.153 5.096 1.127 2.19 3.023 3.46 4.234 2.837m14.993-8.444c1.212-.624 1.28-2.905.154-5.096-1.127-2.19-3.023-3.46-4.235-2.837-1.212.624-1.28 2.905-.154 5.095s3.023 3.461 4.235 2.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F768AB",
    d: "M104.554 114.646a5.415 5.415 0 0 0-7.308-1.993c-2.562 1.424-3.416 4.745-1.993 7.308l5.695 9.87c3.226-1.613 6.263-3.416 9.11-5.504z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 23.974,
    x2: 23.974,
    y1: 45.435,
    y2: 3.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.045,
    stopColor: "#E6E6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F4F4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#FCFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h136v136H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 56.176,
    height: 56.176,
    x: -2.114,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4017_25591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4017_25591",
    result: "shape"
  })))));
};
export default SvgNoResultsImage;